"use client";

import { getTracingContext } from "@offstreetparking/instrumentation/client";
import { type Logger, createLogger } from "@offstreetparking/logger";
import { env } from "./env";

const createClientLogger = (): Logger => {
	const logger = createLogger({ service: env.NEXT_PUBLIC_SERVICE });

	return {
		info: (message: string, context?: Record<string, unknown>) => {
			const tracingContext = getTracingContext();
			logger.info(message, { ...context, ...tracingContext });
		},
		warn: (message: string, context?: Record<string, unknown>) => {
			const tracingContext = getTracingContext();
			logger.warn(message, { ...context, ...tracingContext });
		},
		error: (message: string, err: Error, data?: { logGroup: string } & Record<string, unknown>) => {
			const tracingContext = getTracingContext();
			logger.error(message, err, { logGroup: "BROWSER_ERROR", ...data, ...tracingContext });
		},
		debug: (message: string, context?: Record<string, unknown>) => {
			const tracingContext = getTracingContext();
			logger.debug(message, { ...context, ...tracingContext });
		},
	};
};

export const clientLogger = createClientLogger();
